module.exports = __webpack_public_path__ + "media/images/faces/female/13-950ac3813a4202038916eb80e1d3799c.jpg";